import api from "./axiosInstance";

export const getInvoicesByArtist = async (artistId) => {
  const res = await api.get(
    `api/v1/invoices/?artists=${artistId}`
  );
  return res.data;
};

export const updateInvoice = async (id, payload) => {
  const res = await api.patch(`api/v2/invoices/${id}/`, payload);
  return res.data;
};

export const deleteInvoice = async (id) => {
  await api.delete(`api/v2/invoices/${id}/`);
};
